import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadingStrategy, Route, PreloadAllModules, NoPreloading } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LandingPageComponent } from './shared/components/landing-page/landing-page.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';


const appRoutes: Routes = [
	{
		path: '',
		redirectTo: '/main/dashboard',
		pathMatch: 'full'
	},
	{
		path: 'security',
        loadChildren: () => import('./security/security.module').then(m => m.SecurityModule)
	},
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
	{
		path: 'main',
		canActivateChild: [AuthGuard],
		runGuardsAndResolvers: 'always',
		loadChildren: () => import('./base/base.module').then(m => m.BaseModule)
	},
	{
		path: 'landing-page',
		component: LandingPageComponent
	},
	{
		path: '**',
		component: PageNotFoundComponent
	},
  {
    path: 'security/login',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes,
		{ preloadingStrategy: NoPreloading }
	)],
	exports: [RouterModule],
	providers: []
})
export class RoutingModule { }
